import React from 'react';
import { Button } from '../ui/Button';
import { PlayCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-4 md:pt-28 md:pb-24 max-w-5xl mx-auto text-center" data-id="element-99">
      <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-8" data-id="element-100">
        Aprendé a Editar Videos Profesionales En 7 Días y
        <br data-id="element-101" />
        <span className="text-blue-400" data-id="element-102">Generá +$1000 USD</span>
        <br data-id="element-103" />
        <span className="text-blue-400" data-id="element-104">Extra al Mes</span>
      </h1>

      {/* VSL Video Player */}
      <div className="relative w-full max-w-4xl mx-auto aspect-video bg-slate-900 rounded-2xl shadow-2xl overflow-hidden mb-8 border border-slate-800" data-id="element-105">
        <iframe src="https://player.vimeo.com/video/1171882940?title=0&byline=0&portrait=0" className="absolute top-0 left-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-id="element-106"></iframe>
      </div>

      <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-107">
        Un método práctico para transformar la edición en una habilidad rentable
        y aplicable a clientes reales, aunque hoy no sepas por dónde empezar,
        sin experiencia previa ni equipos caros.
      </p>

      <Button href="https://brunocairo.com/cart/50636149457129:1" size="xl" isExternal className="w-full md:w-auto md:px-12 animate-pulse-slow" data-id="element-108">
        ¡Quiero empezar hoy!
      </Button>
    </section>;
}